import React from 'react'
import GoogleChart from "react-google-charts";

export type TDataItem = [number, number, number]
export interface IChart {
  data: TDataItem[]
}

const Chart: React.FC<IChart> = ({ data }) => {
  const rows = [['Time of Day', 'Размер пенсии', 'Индексация'], ...data]
  return (
    <GoogleChart
      width={1140}
      height={400}
      chartType="ColumnChart"
      data={rows}
      options={{
        backgroundColor: 'f3f3f3',
        titlePosition: 'center',
        isStacked: true,
        legend: 'none',
        colors: [
            '#4f81bd',
            '#92d050',
        ],
      }}
    />
  )
}

export default Chart